import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import Environment from "../../utils/Environment";
import { getGemsTokenContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import { chain } from "lodash";
import Web3 from "web3";

export const GetBalance = () => {
  const web3 = useWeb3();
  const { account, chainId } = useWeb3React();
  const GetBal = useCallback(async (tokenAddress) => {
    try{
    const contract = getGemsTokenContract(tokenAddress, web3);
    const approved = await contract.methods.balanceOf(account).call();
    const balance = approved / 10 ** 18;
    return balance;
  } catch (error) {
    throw error;
  }
  }, [web3, account]);

  return { GetBal: GetBal };
};

export default GetBalance;
